import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_RoomSetup } from "../shared/data.service";
import { RoomModifyRequest } from "../shared/room-modify-request";

@Component({
	selector: "app-edit-room",
	templateUrl: "./edit-room.component.html",
	styleUrls: ["./edit-room.component.css"],
})
export class EditRoomComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private dataService: DataService_RoomSetup,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.SelectedRoom = this.dialogConfig.data.SelectedRoom;
		this.RoomNo = this.SelectedRoom.RoomNo;
		this.RoomDesc = this.SelectedRoom.RoomDesc;
		this.IsImported = this.SelectedRoom.IsImported;

		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolFullName;
	}

	////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////

	SelectedRoom: any;
	RoomNo: string = "";
	RoomDesc: string = "";
	IsImported: boolean = true;
	SelectedSchool: any;
	SchoolName: string = "";

	Processing: boolean = false;
	errorMessage: string = "";

	////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.RoomNo == undefined || this.RoomNo == "") {
			this.errorMessage = "Enter a Room Number";
			return;
		}
		if (this.RoomDesc == undefined || this.RoomDesc == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		this.Processing = true;

		var parms: RoomModifyRequest = {
			RoomID: this.SelectedRoom.RoomID,
			SchoolID: this.SelectedSchool.SchoolID,
			RoomNo: this.RoomNo,
			RoomDesc: this.RoomDesc,
		};

		var result = this.dataService.RoomUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "roomedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Room was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "roomedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Room: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	////////////////////////////////////////////////////////////////
}
